import { FC } from 'react';

import CopyableField from 'dashboard/components/CopyableField';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

interface IssueRecoveryCodeModalProps {
  recoveryCode: string | undefined;
  onClose: () => void;
}

const IssueRecoveryCodeModal: FC<IssueRecoveryCodeModalProps> = ({ recoveryCode, onClose }) => {
  return (
    <ModalContainer>
      <ModalHeader onClose={onClose}>Account recovery code</ModalHeader>

      <ModalBody>
        <Paragraph>Your team member can use this code to regain access to their account.</Paragraph>
        <Spacer height={2} />
        <Paragraph>
          <strong>This code will only be displayed once.</strong>
        </Paragraph>
        <Spacer height={2} />

        <CopyableField value={recoveryCode ?? ''} data-test='issue-recovery-code-modal__code' />
      </ModalBody>
    </ModalContainer>
  );
};

export default IssueRecoveryCodeModal;
